import Svg from '../common/Svg';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReactEcharts from "echarts-for-react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { getDefaultReport, getSurveyResult, getSurveySectionData, getSurveyDetail, getStages } from '../store/actions/surveyFormAction';

import Report from './report/Report';
import { donwloadPdfFile } from '../store/actions/donwloadPdfAction';


export default function ThankyouVersion1() {

    //States
    const [isMobile, setIsMobile] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const { survey_id, ss_id } = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const result = useSelector((state) => state.surveyData?.surveyResult)
    const surveySections = useSelector((state) => state.surveyData?.surveySections)
    const surveyDetail = useSelector((state) => state.surveyData?.surveyDetail)
    const stageData = useSelector((state) => state.surveyData?.stageData)

    const [theme, setTheme] = useState(-1);
    console.log("stageData---", stageData)

    const { defaultReport } = useSelector((state) => state.surveyData)
    const [description, setDescription] = React.useState("");
    const [pageHeading, setPageHeading] = React.useState("");
    const [viewBtn, setViewBtn] = React.useState("");
    const [downloadBtn, setDownloadBtn] = React.useState("");



    //Scrolling config
    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 }

    function preventDefault(e) {
        e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    // modern Chrome requires { passive: false } when adding event
    let supportsPassive = false;
    try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            get: function () { supportsPassive = true; }
        }))
    } catch (e) { }

    let wheelOpt = supportsPassive ? { passive: false } : false;
    let wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    const disableScroll = () => {
        window.addEventListener('DOMMouseScroll', preventDefault, false);
        window.addEventListener(wheelEvent, preventDefault, wheelOpt);
        window.addEventListener('touchmove', preventDefault, wheelOpt);
        window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    const enableScroll = () => {
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
        window.removeEventListener('touchmove', preventDefault, wheelOpt);
        window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    //Download PDF
    const pdfRef = useRef(null)
    const printDocument = async () => {
        // setIsLoading(true)
        // disableScroll()
        // pdfRef.current.style.display = 'block'
        // await loadImageData()
        // await getPDF()
        // pdfRef.current.style.display = 'none'
        // enableScroll()
        // setIsLoading(false)
        if (!defaultReport?.default_report) {
            console.error("Default report not loaded yet");
            return;
        }
        setIsLoading(true)
        // Get the current hostname and protocol
        const currentHostname = window.location.host;
        const currentProtocol = window.location.protocol;
        const data = {
            url: `${currentProtocol}//${currentHostname}/report/${survey_id}/${ss_id}/${defaultReport.default_report}?ispdf=true`,
            survey_id: survey_id,
            ss_id: ss_id,
        };
        dispatch(donwloadPdfFile(data))
            .then(() => { setIsLoading(false) })
            .catch((err) => { setIsLoading(false) })
    }

    const getPDF = async () => {
        const elems = pdfRef.current?.children[0]?.children

        const pdf = new jsPDF("landscape", "px", undefined, true)

        for (let i = 0; i < elems.length; i++) {
            const elementHeight = elems[i].offsetHeight
            const elementWidth = elems[i].offsetWidth
            pdf.addPage([elementWidth / 2, elementHeight / 2]);
        }

        const pages = []

        for (let i = 0; i < elems.length; i++) {
            let htmlData = elems[i]
            pages.push(html2canvas(htmlData, { scale: 3 }))
        }

        await Promise.all(pages).then((values) => {
            for (let i = 0; i < values.length; i++) {
                const elementHeight = elems[i].offsetHeight
                const elementWidth = elems[i].offsetWidth

                // console.log('elementHeight', elementHeight)
                // console.log('elementWidth', elementWidth)

                let imgSrc = values[i].toDataURL("image/jpeg")
                let imgageData = new Image()

                // const pdfWidth = pdf.internal.pageSize.getWidth();
                // const pdfHeight = pdf.internal.pageSize.getHeight();

                if (imgSrc.split(',')[1] === '') {
                    //Adding blank image if there is no data
                    imgSrc = 'data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

                }
                imgageData.src = imgSrc;
                imgageData.onload = () => {
                    pdf.setPage(i + 2)
                    pdf.addImage(imgageData, "JPEG", 0, 0, elementWidth / 2, elementHeight / 2, '', 'FAST')

                    if (i === elems.length - 1) {
                        pdf.deletePage(1)
                        setTimeout(() => {
                            pdf.save()
                        }, 0)
                    }
                }
            }
        });

    }

    // const getPDF = async () => {
    //     const elems = pdfRef.current?.children[0]?.children

    //     // console.log('elems', elems[17])
    //     // const pdf = new jsPDF("landscape", "px")
    //     const pdf = new jsPDF("landscape", "px", undefined, true)

    //     for (let i = 0; i < elems.length; i++) {
    //         let htmlData = elems[i]

    //         await html2canvas(htmlData, { scale: 3 })
    //             .then(async (canvas) => {
    //                 const elementHeight = elems[i].offsetHeight
    //                 const elementWidth = elems[i].offsetWidth

    //                 // console.log('elementHeight', elementHeight)
    //                 // console.log('elementWidth', elementWidth)

    //                 let imgSrc = canvas.toDataURL("image/png")
    //                 let imgageData = new Image()

    //                 // const pdfWidth = pdf.internal.pageSize.getWidth();
    //                 // const pdfHeight = pdf.internal.pageSize.getHeight();

    //                 if (imgSrc.split(',')[1] === '') {
    //                     //Adding blank image if there is no data
    //                     imgSrc = 'data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    //                 }

    //                 imgageData.src = imgSrc;
    //                 imgageData.onload = () => {
    //                     pdf.addPage([elementWidth / 2, elementHeight / 2]);
    //                     pdf.addImage(imgageData, "PNG", 0, 0, elementWidth / 2, elementHeight / 2)
    //                     // console.log('Page:', i + 1, imgSrc)

    //                     if (i === elems.length - 1) {
    //                         pdf.deletePage(1)
    //                         pdf.save()
    //                     }
    //                 }

    //             }).catch((error) => {
    //                 console.log('Add page error', error)
    //             })
    //     }
    // }

    const loadImageData = async () => {
        const elems = pdfRef.current?.children[0]?.children
        for (let i = 0; i < elems.length; i++) {
            let liveImages = elems[i].querySelectorAll('img')
            for (let j = 0; j < liveImages.length; j++) {
                const liveLink = liveImages[j].src
                const protocol = liveLink.split('://')[0]
                if (protocol === 'http' || protocol === 'https') {
                    await getBase64FromUrl(liveLink).then((data) => {
                        liveImages[j].src = data
                    }).catch((error) => {
                        console.log('Image fetching error', error)
                    })
                }
            }
        }

        var rawElems = pdfRef.current?.children[0]?.querySelectorAll('*')

        for (let i = 0; i < rawElems.length; i++) {
            let element = rawElems[i]
            const styles = window.getComputedStyle(element);

            const gackgroundImage = styles.getPropertyValue('background-image')
            if (gackgroundImage !== 'none') {
                const liveLink = gackgroundImage?.split('"')[1]
                const protocol = liveLink?.split('://')[0]

                if (protocol === 'http' || protocol === 'https') {
                    await getBase64FromUrl(liveLink).then((data) => {
                        element.style.backgroundImage = `url(${data})`
                    }).catch((error) => {
                        console.log('Image fetching error', error)
                    })
                }
            }
        }
    }

    // const getBase64Image = (img, callBack) => {
    //     img.setAttribute('crossorigin', 'anonymous');
    //     img.onload = () => {
    //         var canvas = document.createElement("canvas");
    //         canvas.width = img.width + 5;
    //         canvas.height = img.height + 5;
    //         var ctx = canvas.getContext("2d");
    //         ctx.drawImage(img, 0, 0);
    //         let dataURL = canvas.toDataURL("image/png");
    //         const src = `${img.src}`
    //         if (!src?.includes('data:image/png;base64'))
    //             callBack(dataURL)
    //     }
    // }

    const getBase64FromUrl = async (url) => {
        try {
            const data = await fetch(url, {
                method: 'get',
                mode: 'cors',
                cache: 'no-store',
                headers: {
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache'
                }
            })
            const blob = await data.blob()

            return new Promise((resolve) => {
                const reader = new FileReader()
                reader.readAsDataURL(blob)
                reader.onloadend = () => {
                    let base64data = reader.result;
                    const rawData = base64data?.split('base64,')
                    base64data = 'data:image/png;base64,' + rawData[1]
                    resolve(base64data)
                }
            })

        } catch (err) {
            console.log('FETCH IMAGE ERR', err, '---', url)
        }
    }

    //Colors
    const sectionColors = ['#9C2AA0', '#E60000', '#A8B400', '#EB9700', '#00B0CA', '#4A4D4E']

    //Options and style
    const style = {
        height: isMobile ? '300px' : '450px',
        width: '100%',
        // add the chart-container class
        className: 'chart-container',
    }

    const option = useMemo(() => {

        //Intervals and max value
        const interval = Number(result?.graph_interval ?? 3)
        const intervalCount = Number(result?.graph_interval_count ?? 100)
        const maxValue = interval * intervalCount

        //Functionalities
        const getIndicator = (name, colorIndex) => {
            return { name: name, max: maxValue, color: sectionColors[colorIndex] }
        }

        //Get sections and indicators
        let indicators = []
        let values = []
        const sectionWithScore = result?.section_maturity_score

        Object.keys(sectionWithScore ?? {})?.forEach((key, index) => {
            indicators.push(getIndicator(surveySections[key]?.name, index))
            values.push(Number(sectionWithScore[key]))
        })

        indicators.push(indicators.shift())

        //Return if data
        if (indicators.length > 0 && values.length > 0) {
            values.push(values.shift())
            return {
                radar: {
                    indicator: indicators.reverse(),
                    name: {
                        textStyle: {
                            fontSize: isMobile ? 12 : 16,
                            fontWeight: 'bold',
                            className: 'chart-title',
                        },
                    },
                    splitNumber: intervalCount,
                },
                series: [
                    {
                        name: 'Digital Maturity Radar',
                        type: 'radar',
                        color: '#E60000',
                        areaStyle: { // added areaStyle option here
                            color: 'rgba(230, 0, 0, .2)', // set the background color of the plotted area
                        },
                        data: [
                            {
                                value: values.reverse()
                            }
                        ]
                    }
                ]
            }
        }

        //Return this id there isn't any data
        return {
            radar: {
                indicator: [{ name: '', max: 10 }, { name: '', max: 10 }, { name: '', max: 10 }],
                name: {
                    textStyle: {
                        fontSize: isMobile ? 12 : 16,
                        fontWeight: 'bold',
                        className: 'chart-title',
                    },
                },
            },
            series: [
                {
                    name: 'Digital Maturity Radar',
                    type: 'radar',
                    color: '#E60000',
                    areaStyle: { // added areaStyle option here
                        color: 'rgba(230, 0, 0, .2)', // set the background color of the plotted area
                    },
                    data: [
                        {
                            value: [0]
                        }
                    ]
                }
            ]
        }

    }, [surveySections, result, isMobile])

    //Effects
    useEffect(() => {
        // Check if the window width is less than 768px (i.e., a mobile device)
        setIsMobile(window.innerWidth < 768);

        // Update the isMobile state variable whenever the window is resized
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [])

    useEffect(() => {
        let token = localStorage.getItem("customer_token")
        if (!token || !ss_id || ss_id === 'undefined' || !survey_id) {
            navigate('/')
        }
        else {
            dispatch(getSurveySectionData({
                "survey_id": survey_id
            }))

            dispatch(getDefaultReport(survey_id))
            dispatch(getSurveyResult({ survey_id, ss_id }))
            dispatch(getSurveyDetail({
                "survey_id": survey_id
            }))
            dispatch(getStages({
                "survey_id": survey_id
            }))
        }
    }, [survey_id, ss_id])

    useEffect(() => {
        if (surveyDetail?.length > 0) {
            console.log("survey detail-------", surveyDetail)
            // setTheme([surveyDetail[0].theme_selected]);
            setPageHeading(surveyDetail[0].thankyou_heading)
            setDescription(surveyDetail[0].thankyou_description);
            setViewBtn(surveyDetail[0].thankyou_view_button);
            setDownloadBtn(surveyDetail[0].thankyou_download_button);
        }

    }, [surveyDetail])

    function replaceHashtags(template, data) {
        // Create a mapping for keys that have different names in the data
        const keyMap = {
            'maturity_stage': 'stage',
        };

        return template.replace(/#\[(?:leadForm:)?(.*?)\]#/g, (_, key) => {
            let value;

            // Map the key if necessary
            const actualKey = keyMap[key] || key;

            // Try accessing the key in the root data object
            if (actualKey in data) {
                value = data[actualKey];
            }
            // If not found, try accessing it in data.info
            else if (data.info && actualKey in data.info) {
                value = data.info[actualKey];
            }

            // Return the value or the original placeholder if not found
            return value !== undefined ? value : `#[${key}]#`;
        });
    }

    // Apply the replacement using result?.info
    const pageContent = replaceHashtags(pageHeading, result);

    const calculateProgressWidth = (stageData, result, index) => {
        // Find the index of user's current stage
        const userStageIndex = stageData?.findIndex(
            (s) => JSON.parse(s.su_stage_name)?.['22']?.toLowerCase() === result?.stage?.toLowerCase()
        );

        // If we're not at an active stage, return 0
        if (index > userStageIndex) return '0%';

        // Calculate the sum of 'to' values up to the current stage
        let currentSum = 0;
        for (let i = 0; i <= userStageIndex; i++) {
            const formulas = JSON.parse(stageData[i].su_stage_formulas);
            const stageTo = parseFloat(formulas.to) || 0;
            if (i <= index) {
                currentSum += stageTo;
            }
        }

        // Calculate total of all 'to' values
        const totalSum = stageData?.reduce((sum, stage) => {
            const formulas = JSON.parse(stage.su_stage_formulas);
            const stageTo = parseFloat(formulas.to) || 0;
            return sum + stageTo;
        }, 0);

        // Calculate percentage
        const percentage = (currentSum / totalSum) * 100;
        return `${percentage}%`;
    };

    return (
        <>
            <div className='thank-you-page'>
                <div className="container" id='container1234'>
                    <div className="row">
                        <div className="col-lg-6 mb-3 mb-lg-0">
                            <div className="text-wrap">
                                <div className="logo-wrap">
                                    <Svg name="vodafone-logo-colored" />
                                </div>
                                {/* <h1><span className='text-primary'>{`${result?.info?.con_first_name ?? (result?.info?.firstName ?? '')} ${result?.info?.con_last_name ?? (result?.info?.lastName ?? '')}`},</span> {`${result?.info?.company ?? ''}`} is at the <span className='text-primary'>{result?.stage && `${result?.stage}`}</span> stage</h1> */}
                                <h1>{pageContent}</h1>
                                <div className="progress-wrapper">
                                    <div className="progress-output">
                                        <div className="progress-output">
                                            <ul>
                                                {stageData?.map((stage, index) => {
                                                    const stageName = JSON.parse(stage.su_stage_name)?.['22'];
                                                    const userStageIndex = stageData.findIndex(
                                                        (s) => JSON.parse(s.su_stage_name)?.['22']?.toLowerCase() === result?.stage?.toLowerCase()
                                                    );
                                                    const isActive = index <= userStageIndex;

                                                    return (
                                                        <li
                                                            key={stage.su_survey_stages_id}
                                                            className={`${isActive ? 'active' : ''} icon-text-wrap`}
                                                        >
                                                            <div className="icon-wrap">
                                                                <Svg
                                                                    name={`${index === 0
                                                                        ? 'beginner-icon'
                                                                        : index === stageData.length - 1
                                                                            ? 'intermediate-icon'
                                                                            : 'advanced-icon'
                                                                        }`}
                                                                />
                                                            </div>
                                                            <div className="text">{stageName}</div>
                                                        </li>
                                                    );
                                                })}
                                                <div className="result-bar" style={{
                                                    width: calculateProgressWidth(stageData, result,
                                                        stageData?.findIndex(s =>
                                                            JSON.parse(s.su_stage_name)?.['22']?.toLowerCase() === result?.stage?.toLowerCase()
                                                        )
                                                    )
                                                }}></div>
                                            </ul>
                                        </div>



                                    </div>
                                </div>

                                <p>{description}</p>
                                <div className="button-wrap d-flex flex-wrap">
                                    <Link to={`/report/${survey_id}/${ss_id}/${defaultReport?.default_report}`} className='btn btn-primary me-0 me-md-3 mb-3'> {viewBtn} </Link>
                                    <button className='btn btn-transparent btn-icon mb-3' onClick={printDocument} disabled={isLoading}>
                                        {downloadBtn}
                                        {
                                            isLoading ? <div className="spinner-border text-danger" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div> : <Svg name="button-icon" />
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="graph-box">
                                <div className="chart-wrapper">
                                    <ReactEcharts style={style} option={option} />
                                </div>
                                <div className="value-wrapper">
                                    {
                                        Object.keys(result?.section_maturity_score ?? {})?.map((key, index) => {
                                            return (
                                                <div className={`value-box value-${(index % 6) + 1}`} key={index}>
                                                    <div className="number">{(result?.section_maturity_score[key])}</div>
                                                    <div className="text">{surveySections[key]?.name}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className='SurveyReportPreview' id='SurveyReportPreview' ref={pdfRef} style={{ display: 'block' }}>
                <Report SRID={defaultReport?.default_report} />
            </div> */}
        </>
    )
}
